import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <G fill="#333">
        <Path d="M9 20.786h8.578c.022-.023.04-.048.064-.07l.832-.716H12.41a.679.679 0 01-.672-.578 1.585 1.585 0 00-.77-1.174 1.56 1.56 0 00-.593-.2.681.681 0 01-.59-.672V12.41a.679.679 0 01.578-.672c.275-.033.536-.137.758-.302a1.559 1.559 0 00.616-1.061.682.682 0 01.673-.59h12.037a.68.68 0 01.672.583 1.57 1.57 0 001.368 1.37.68.68 0 01.584.672v4.966a.679.679 0 01-.577.671 1.585 1.585 0 00-1.175.77 1.56 1.56 0 00-.2.594.674.674 0 01-.039.15c.942.25 1.831.664 2.627 1.225h.15V9H9v11.786z" />
        <Path d="M30.748 31a.244.244 0 00.177-.074.265.265 0 00.075-.193C30.776 21.863 26.177 20 22.357 20a.393.393 0 01-.393-.393v-.833a.34.34 0 00-.201-.314.327.327 0 00-.36.05l-3.248 2.802a.342.342 0 000 .52l3.249 2.801a.327.327 0 00.36.05.34.34 0 00.2-.314v-.833a.393.393 0 01.393-.393c5.945 0 7.74 5.87 8.15 7.668a.246.246 0 00.24.189z" />
        <Path d="M24.353 19.214a2.338 2.338 0 01.91-1.493c.301-.224.651-.374 1.022-.437v-4.782a2.353 2.353 0 01-1.931-1.93H12.502a2.337 2.337 0 01-.91 1.492c-.301.225-.651.375-1.022.438v4.781a2.34 2.34 0 011.493.91c.225.3.375.65.438 1.021h6.883l1.506-1.298a1.127 1.127 0 011.859.859v.44h1.604zm-5.926-1.571a2.75 2.75 0 110-5.501 2.75 2.75 0 010 5.5z" />
        <Path d="M18.43 16.857a1.964 1.964 0 100-3.928 1.964 1.964 0 000 3.928z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
